import { Box, type SxProps, type Theme } from '@mui/material';
import type { ReactNode } from 'react';
import { SEMANTIC_COLOR_VARS, type SemanticColor } from './semanticColor';

type IconTileSize = 'sm' | 'md' | 'lg';

const SIZE_PX: Record<IconTileSize, number> = { sm: 28, md: 36, lg: 48 };
const FONT_PX: Record<IconTileSize, number> = { sm: 13, md: 17, lg: 22 };

interface IconTileProps {
  icon: ReactNode;
  color?: SemanticColor;
  size?: IconTileSize;
  sx?: SxProps<Theme>;
}

/**
 * Rounded-square colored icon badge — the repeated icon-tile pattern used on
 * section headers, agent cards, and stat tiles throughout the redesign.
 */
export function IconTile({ icon, color = 'primary', size = 'md', sx }: IconTileProps) {
  const vars = SEMANTIC_COLOR_VARS[color];
  return (
    <Box
      sx={{
        width: SIZE_PX[size],
        height: SIZE_PX[size],
        fontSize: FONT_PX[size],
        borderRadius: 'var(--radius-md)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        color: vars.main,
        backgroundColor: vars.soft,
        border: '1px solid',
        borderColor: vars.line,
        '& svg': { fontSize: 'inherit' },
        ...sx,
      }}
    >
      {icon}
    </Box>
  );
}
